module.exports = __webpack_public_path__ + "42cd01a829357eae54b49fbd1d1e2d5a.pdf";